var _g, _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path0, _mask6, _path1, _path10, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 509,
    height: 250,
    viewBox: "0 0 509 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4269_73372)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.3042,
    y: 14,
    width: 432.372,
    height: 221.6,
    rx: 8,
    fill: "white"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_4269_73372",
    maskUnits: "userSpaceOnUse",
    x: 58.8492,
    y: 43.2207,
    width: 385,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 58.8492,
    y: 43.2207,
    width: 385,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8492 62.2207C59.8492 66.639 63.431 70.2207 67.8492 70.2207H434.415C438.834 70.2207 442.415 66.639 442.415 62.2207V52.3346C442.415 47.9163 438.834 44.3346 434.415 44.3346H67.8492C63.431 44.3346 59.8492 47.9163 59.8492 52.3346V62.2207Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8492 62.2207C59.8492 66.639 63.431 70.2207 67.8492 70.2207H434.415C438.834 70.2207 442.415 66.639 442.415 62.2207V52.3346C442.415 47.9163 438.834 44.3346 434.415 44.3346H67.8492C63.431 44.3346 59.8492 47.9163 59.8492 52.3346V62.2207Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8492 62.2207C58.8492 67.1913 62.8787 71.2207 67.8492 71.2207H434.415C439.386 71.2207 443.415 67.1913 443.415 62.2207H441.415C441.415 66.0867 438.281 69.2207 434.415 69.2207H67.8492C63.9832 69.2207 60.8492 66.0867 60.8492 62.2207H58.8492ZM443.415 52.3346C443.415 47.3641 439.386 43.3346 434.415 43.3346H67.8492C62.8787 43.3346 58.8492 47.3641 58.8492 52.3346H60.8492C60.8492 48.4686 63.9832 45.3346 67.8492 45.3346H434.415C438.281 45.3346 441.415 48.4686 441.415 52.3346H443.415ZM67.8492 43.3346C62.8787 43.3346 58.8492 47.3641 58.8492 52.3346V62.2207C58.8492 67.1913 62.8787 71.2207 67.8492 71.2207V69.2207C63.9832 69.2207 60.8492 66.0867 60.8492 62.2207V52.3346C60.8492 48.4686 63.9832 45.3346 67.8492 45.3346V43.3346ZM434.415 71.2207C439.386 71.2207 443.415 67.1913 443.415 62.2207V52.3346C443.415 47.3641 439.386 43.3346 434.415 43.3346V45.3346C438.281 45.3346 441.415 48.4686 441.415 52.3346V62.2207C441.415 66.0867 438.281 69.2207 434.415 69.2207V71.2207Z",
    fill: "#E1DFDD",
    mask: "url(#path-2-outside-1_4269_73372)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-2_4269_73372",
    maskUnits: "userSpaceOnUse",
    x: 58.8492,
    y: 70.2144,
    width: 385,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 58.8492,
    y: 70.2144,
    width: 385,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8492 89.2144C59.8492 93.6326 63.431 97.2144 67.8492 97.2144H434.415C438.834 97.2144 442.415 93.6326 442.415 89.2144V79.3283C442.415 74.91 438.834 71.3283 434.415 71.3283H67.8492C63.431 71.3283 59.8492 74.91 59.8492 79.3283V89.2144Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8492 89.2144C59.8492 93.6326 63.431 97.2144 67.8492 97.2144H434.415C438.834 97.2144 442.415 93.6326 442.415 89.2144V79.3283C442.415 74.91 438.834 71.3283 434.415 71.3283H67.8492C63.431 71.3283 59.8492 74.91 59.8492 79.3283V89.2144Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8492 89.2144C58.8492 94.1849 62.8787 98.2144 67.8492 98.2144H434.415C439.386 98.2144 443.415 94.1849 443.415 89.2144H441.415C441.415 93.0803 438.281 96.2144 434.415 96.2144H67.8492C63.9832 96.2144 60.8492 93.0803 60.8492 89.2144H58.8492ZM443.415 79.3283C443.415 74.3577 439.386 70.3283 434.415 70.3283H67.8492C62.8787 70.3283 58.8492 74.3577 58.8492 79.3283H60.8492C60.8492 75.4623 63.9832 72.3283 67.8492 72.3283H434.415C438.281 72.3283 441.415 75.4623 441.415 79.3283H443.415ZM67.8492 70.3283C62.8787 70.3283 58.8492 74.3577 58.8492 79.3283V89.2144C58.8492 94.1849 62.8787 98.2144 67.8492 98.2144V96.2144C63.9832 96.2144 60.8492 93.0803 60.8492 89.2144V79.3283C60.8492 75.4623 63.9832 72.3283 67.8492 72.3283V70.3283ZM434.415 98.2144C439.386 98.2144 443.415 94.1849 443.415 89.2144V79.3283C443.415 74.3577 439.386 70.3283 434.415 70.3283V72.3283C438.281 72.3283 441.415 75.4623 441.415 79.3283V89.2144C441.415 93.0803 438.281 96.2144 434.415 96.2144V98.2144Z",
    fill: "#E1DFDD",
    mask: "url(#path-4-outside-2_4269_73372)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-3_4269_73372",
    maskUnits: "userSpaceOnUse",
    x: 58.8492,
    y: 97.208,
    width: 385,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 58.8492,
    y: 97.208,
    width: 385,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8492 116.208C59.8492 120.626 63.431 124.208 67.8492 124.208H434.415C438.834 124.208 442.415 120.626 442.415 116.208V106.322C442.415 101.904 438.834 98.3219 434.415 98.3219H67.8492C63.431 98.3219 59.8492 101.904 59.8492 106.322V116.208Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8492 116.208C59.8492 120.626 63.431 124.208 67.8492 124.208H434.415C438.834 124.208 442.415 120.626 442.415 116.208V106.322C442.415 101.904 438.834 98.3219 434.415 98.3219H67.8492C63.431 98.3219 59.8492 101.904 59.8492 106.322V116.208Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8492 116.208C58.8492 121.179 62.8787 125.208 67.8492 125.208H434.415C439.386 125.208 443.415 121.179 443.415 116.208H441.415C441.415 120.074 438.281 123.208 434.415 123.208H67.8492C63.9832 123.208 60.8492 120.074 60.8492 116.208H58.8492ZM443.415 106.322C443.415 101.351 439.386 97.3219 434.415 97.3219H67.8492C62.8787 97.3219 58.8492 101.351 58.8492 106.322H60.8492C60.8492 102.456 63.9832 99.3219 67.8492 99.3219H434.415C438.281 99.3219 441.415 102.456 441.415 106.322H443.415ZM67.8492 97.3219C62.8787 97.3219 58.8492 101.351 58.8492 106.322V116.208C58.8492 121.179 62.8787 125.208 67.8492 125.208V123.208C63.9832 123.208 60.8492 120.074 60.8492 116.208V106.322C60.8492 102.456 63.9832 99.3219 67.8492 99.3219V97.3219ZM434.415 125.208C439.386 125.208 443.415 121.179 443.415 116.208V106.322C443.415 101.351 439.386 97.3219 434.415 97.3219V99.3219C438.281 99.3219 441.415 102.456 441.415 106.322V116.208C441.415 120.074 438.281 123.208 434.415 123.208V125.208Z",
    fill: "#E1DFDD",
    mask: "url(#path-6-outside-3_4269_73372)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-4_4269_73372",
    maskUnits: "userSpaceOnUse",
    x: 58.8492,
    y: 124.241,
    width: 385,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 58.8492,
    y: 124.241,
    width: 385,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8492 143.241C59.8492 147.659 63.431 151.241 67.8492 151.241H434.415C438.834 151.241 442.415 147.659 442.415 143.241V133.355C442.415 128.937 438.834 125.355 434.415 125.355H67.8492C63.431 125.355 59.8492 128.937 59.8492 133.355V143.241Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8492 143.241C59.8492 147.659 63.431 151.241 67.8492 151.241H434.415C438.834 151.241 442.415 147.659 442.415 143.241V133.355C442.415 128.937 438.834 125.355 434.415 125.355H67.8492C63.431 125.355 59.8492 128.937 59.8492 133.355V143.241Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8492 143.241C58.8492 148.212 62.8787 152.241 67.8492 152.241H434.415C439.386 152.241 443.415 148.212 443.415 143.241H441.415C441.415 147.107 438.281 150.241 434.415 150.241H67.8492C63.9832 150.241 60.8492 147.107 60.8492 143.241H58.8492ZM443.415 133.355C443.415 128.384 439.386 124.355 434.415 124.355H67.8492C62.8787 124.355 58.8492 128.384 58.8492 133.355H60.8492C60.8492 129.489 63.9832 126.355 67.8492 126.355H434.415C438.281 126.355 441.415 129.489 441.415 133.355H443.415ZM67.8492 124.355C62.8787 124.355 58.8492 128.384 58.8492 133.355V143.241C58.8492 148.212 62.8787 152.241 67.8492 152.241V150.241C63.9832 150.241 60.8492 147.107 60.8492 143.241V133.355C60.8492 129.489 63.9832 126.355 67.8492 126.355V124.355ZM434.415 152.241C439.386 152.241 443.415 148.212 443.415 143.241V133.355C443.415 128.384 439.386 124.355 434.415 124.355V126.355C438.281 126.355 441.415 129.489 441.415 133.355V143.241C441.415 147.107 438.281 150.241 434.415 150.241V152.241Z",
    fill: "#E1DFDD",
    mask: "url(#path-8-outside-4_4269_73372)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-outside-5_4269_73372",
    maskUnits: "userSpaceOnUse",
    x: 58.8492,
    y: 150.059,
    width: 385,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 58.8492,
    y: 150.059,
    width: 385,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8492 169.059C59.8492 173.478 63.431 177.059 67.8492 177.059H434.415C438.834 177.059 442.415 173.478 442.415 169.059V159.173C442.415 154.755 438.834 151.173 434.415 151.173H67.8492C63.431 151.173 59.8492 154.755 59.8492 159.173V169.059Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8492 169.059C59.8492 173.478 63.431 177.059 67.8492 177.059H434.415C438.834 177.059 442.415 173.478 442.415 169.059V159.173C442.415 154.755 438.834 151.173 434.415 151.173H67.8492C63.431 151.173 59.8492 154.755 59.8492 159.173V169.059Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8492 169.059C58.8492 174.03 62.8787 178.059 67.8492 178.059H434.415C439.386 178.059 443.415 174.03 443.415 169.059H441.415C441.415 172.925 438.281 176.059 434.415 176.059H67.8492C63.9832 176.059 60.8492 172.925 60.8492 169.059H58.8492ZM443.415 159.173C443.415 154.203 439.386 150.173 434.415 150.173H67.8492C62.8787 150.173 58.8492 154.203 58.8492 159.173H60.8492C60.8492 155.307 63.9832 152.173 67.8492 152.173H434.415C438.281 152.173 441.415 155.307 441.415 159.173H443.415ZM67.8492 150.173C62.8787 150.173 58.8492 154.203 58.8492 159.173V169.059C58.8492 174.03 62.8787 178.059 67.8492 178.059V176.059C63.9832 176.059 60.8492 172.925 60.8492 169.059V159.173C60.8492 155.307 63.9832 152.173 67.8492 152.173V150.173ZM434.415 178.059C439.386 178.059 443.415 174.03 443.415 169.059V159.173C443.415 154.203 439.386 150.173 434.415 150.173V152.173C438.281 152.173 441.415 155.307 441.415 159.173V169.059C441.415 172.925 438.281 176.059 434.415 176.059V178.059Z",
    fill: "#E1DFDD",
    mask: "url(#path-10-outside-5_4269_73372)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-outside-6_4269_73372",
    maskUnits: "userSpaceOnUse",
    x: 58.8492,
    y: 177.092,
    width: 385,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 58.8492,
    y: 177.092,
    width: 385,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8492 196.092C59.8492 200.51 63.431 204.092 67.8492 204.092H434.415C438.834 204.092 442.415 200.51 442.415 196.092V186.206C442.415 181.788 438.834 178.206 434.415 178.206H67.8492C63.431 178.206 59.8492 181.788 59.8492 186.206V196.092Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8492 196.092C59.8492 200.51 63.431 204.092 67.8492 204.092H434.415C438.834 204.092 442.415 200.51 442.415 196.092V186.206C442.415 181.788 438.834 178.206 434.415 178.206H67.8492C63.431 178.206 59.8492 181.788 59.8492 186.206V196.092Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8492 196.092C58.8492 201.063 62.8787 205.092 67.8492 205.092H434.415C439.386 205.092 443.415 201.063 443.415 196.092H441.415C441.415 199.958 438.281 203.092 434.415 203.092H67.8492C63.9832 203.092 60.8492 199.958 60.8492 196.092H58.8492ZM443.415 186.206C443.415 181.235 439.386 177.206 434.415 177.206H67.8492C62.8787 177.206 58.8492 181.235 58.8492 186.206H60.8492C60.8492 182.34 63.9832 179.206 67.8492 179.206H434.415C438.281 179.206 441.415 182.34 441.415 186.206H443.415ZM67.8492 177.206C62.8787 177.206 58.8492 181.235 58.8492 186.206V196.092C58.8492 201.063 62.8787 205.092 67.8492 205.092V203.092C63.9832 203.092 60.8492 199.958 60.8492 196.092V186.206C60.8492 182.34 63.9832 179.206 67.8492 179.206V177.206ZM434.415 205.092C439.386 205.092 443.415 201.063 443.415 196.092V186.206C443.415 181.235 439.386 177.206 434.415 177.206V179.206C438.281 179.206 441.415 182.34 441.415 186.206V196.092C441.415 199.958 438.281 203.092 434.415 203.092V205.092Z",
    fill: "#E1DFDD",
    mask: "url(#path-12-outside-6_4269_73372)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.0111,
    y: 54.4709,
    width: 118.379,
    height: 7.21823,
    rx: 3.60911,
    fill: "#EDEDED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.0111,
    y: 80.446,
    width: 94.5588,
    height: 7.21823,
    rx: 3.60911,
    fill: "#EDEDED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75.0111,
    y: 107.166,
    width: 109.717,
    height: 7.21823,
    rx: 3.60911,
    fill: "#EDEDED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75.0111,
    y: 134.59,
    width: 118.379,
    height: 7.21823,
    rx: 3.60911,
    fill: "#EDEDED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75.0111,
    y: 160.565,
    width: 94.5588,
    height: 7.21823,
    rx: 3.60911,
    fill: "#EDEDED"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 75.0111,
    y: 187.285,
    width: 109.717,
    height: 7.21823,
    rx: 3.60911,
    fill: "#EDEDED"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 426.899,
    cy: 57.7131,
    r: 4.19185,
    fill: "#FAF9F8",
    stroke: "#7D8EDF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 426.899,
    cy: 83.6884,
    r: 4.19185,
    fill: "#FAF9F8",
    stroke: "#7D8EDF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 426.899,
    cy: 111.857,
    r: 4.19185,
    fill: "#FAF9F8",
    stroke: "#7D8EDF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 426.899,
    cy: 137.832,
    r: 4.19185,
    fill: "#FAF9F8",
    stroke: "#7D8EDF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 426.899,
    cy: 164.552,
    r: 4.19185,
    fill: "#FAF9F8",
    stroke: "#7D8EDF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 426.899,
    cy: 190.527,
    r: 4.19185,
    fill: "#FAF9F8",
    stroke: "#7D8EDF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M448.859 126.245C448.859 126.245 448.018 124.857 447.505 124.083C446.992 123.318 445.966 122.359 445.697 122.603C445.436 122.847 446.487 123.865 446.437 124.209C446.386 124.546 444.628 123.411 444.435 123.15C444.057 122.637 443.047 122.082 442.921 122.729C442.795 123.377 443.544 125.412 443.888 126.001C444.225 126.59 445.646 127.515 446.437 127.792C447.219 128.07 448.573 128.717 448.573 128.717L448.859 126.245Z",
    fill: "#BF8F68"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M492.078 91.5781H467.817C467.049 110.868 465.292 123.292 465.292 123.292L480.003 124.055L496.25 123.183C496.25 123.183 493.066 103.348 492.078 91.5781Z",
    fill: "#3A312E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M472.508 127.49C472.508 127.49 471.625 129.23 470.036 131.232C468.11 133.637 465.149 136.421 461.424 136.968C459.649 137.229 457.908 136.85 456.31 136.135C451.786 134.125 448.388 129.516 448.388 129.516C447.589 127.347 448.892 125.866 448.892 125.866C448.892 125.866 458.017 127.918 458.892 127.481C459.758 127.044 464.83 112.435 466.041 110.602C467.252 108.769 471.364 107.81 471.364 107.81L472.517 127.481L472.508 127.49Z",
    fill: "#C3C3E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M470.035 131.232C468.109 133.638 465.149 136.421 461.423 136.968C459.649 137.229 457.908 136.85 456.31 136.135C456.487 136.161 461.003 136.716 462.803 133.495C464.636 130.206 466.621 124.992 469.354 126.733C470.532 127.481 470.481 129.349 470.035 131.224V131.232Z",
    fill: "#A4A4D1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M506.561 226.023C506.561 226.023 509.344 228.563 508.806 230.371C508.26 232.179 505.753 233.382 505.409 235.585C505.072 237.789 503.71 239 502.49 239H496.662C496.662 239 495.762 237.444 497.932 236.981C500.102 236.51 500.926 233.92 500.791 231.515C500.657 229.109 500.993 225.897 500.993 225.897L505.61 224.829L506.561 226.031V226.023Z",
    fill: "#707072"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M482.987 227.1C482.987 227.1 483.988 237.865 482.768 238.47L467.117 238.437C467.117 238.437 467.117 236.628 469.632 236.233C472.146 235.829 476.562 234.358 477.31 231.086C478.059 227.814 482.987 227.108 482.987 227.108V227.1Z",
    fill: "#707072"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M476.419 97.6086C476.419 97.6086 475.788 98.4412 474.518 98.3823C473.5 98.3319 473.105 97.4488 473.105 97.4488C473.105 97.4488 474.981 96.9947 476.419 97.6086Z",
    fill: "#EBF3FA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M492.107 92.8376C492.158 84.8324 486.743 78.3084 480.014 78.266C473.284 78.2235 467.787 84.6787 467.736 92.6839C467.686 100.689 473.1 107.213 479.83 107.256C486.56 107.298 492.057 100.843 492.107 92.8376Z",
    fill: "#3A312E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M483.077 104.765C483.077 102.803 483.077 98.6621 483.077 98.6621H477.039C477.039 98.6621 477.039 102.803 477.039 104.656C477.039 106.509 470.759 108.046 470.759 108.046C470.759 108.046 476.425 112.671 479.169 112.671C481.914 112.671 489.682 107.204 489.682 107.204C489.682 107.204 483.077 106.727 483.077 104.765Z",
    fill: "url(#paint0_radial_4269_73372)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M486.589 92.0144C486.589 97.8995 483.076 102.695 478.685 102.695C474.294 102.695 470.781 97.8995 470.781 92.0144C470.781 86.1293 474.294 81.8789 478.685 81.8789C482.966 81.8789 486.589 86.1293 486.589 92.0144Z",
    fill: "#BF8F68"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M478.246 87.0007V90.1612C478.246 91.796 477.367 92.8858 476.819 93.5397C476.489 93.8667 476.379 94.7386 476.819 95.1745C477.038 95.3925 478.136 95.9374 478.136 96.7003L478.246 99.6428H471.659L471.769 87.1097L478.246 87.0007Z",
    fill: "url(#paint1_radial_4269_73372)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M477.039 98.2259C477.697 98.117 478.246 98.008 478.685 97.899C478.905 97.899 479.124 97.79 479.344 97.681C479.564 97.572 479.783 97.4631 480.112 97.2451C480.222 97.1361 480.442 97.2451 480.442 97.3541V97.4631C480.442 97.899 480.332 98.2259 480.003 98.5529C479.783 98.8798 479.344 99.0978 478.905 99.2068C478.136 99.4248 477.258 99.2068 476.709 98.5529C476.6 98.4439 476.6 98.2259 476.709 98.117C476.819 98.2259 476.929 98.2259 477.039 98.2259Z",
    fill: "#9B643D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M482.172 92.1278C482.182 91.4658 481.846 90.924 481.422 90.9177C480.998 90.9114 480.646 91.443 480.636 92.105C480.626 92.767 480.962 93.3088 481.386 93.3151C481.81 93.3214 482.162 92.7898 482.172 92.1278Z",
    fill: "#3A312E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M474.752 93.3232C475.176 93.3168 475.512 92.775 475.503 92.113C475.493 91.451 475.141 90.9194 474.716 90.9258C474.292 90.9321 473.956 91.4739 473.966 92.136C473.976 92.798 474.328 93.3295 474.752 93.3232Z",
    fill: "#3A312E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M485.492 88.0907V90.0524C483.735 89.2895 480.881 88.8536 477.588 88.8536L476.819 85.911L475.941 88.7446C473.196 88.8536 470.781 89.3985 469.354 90.0524H467.927V88.0907C467.927 83.9493 471.44 80.6798 475.721 80.6798H477.697C481.979 80.5708 485.492 83.9493 485.492 88.0907Z",
    fill: "#3A312E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M485.492 82.4238V98.4444C485.492 102.586 487.139 106.509 489.993 109.452C490.323 109.779 490.652 110.215 490.872 110.433V88.6359C490.872 87.764 490.542 86.8921 489.774 86.2382L485.492 82.4238Z",
    fill: "#3A312E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M495.03 120.232C495.03 120.232 495.266 123.52 495.03 127.464C494.879 130.08 492.23 133.579 491.851 134.453C490.909 136.623 489.85 136.976 489.85 136.976L481.633 138.986L478.74 139.693L469.631 136.968C469.631 136.968 465.485 125.387 467.151 118.869C468.816 112.351 471.364 107.818 471.364 107.818C471.364 107.818 478.799 115.101 488.479 107.204L495.03 120.223V120.232Z",
    fill: "#C3C3E1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M492.625 128.532C492.474 131.148 492.23 133.587 491.852 134.453C490.91 136.623 489.85 136.976 489.85 136.976L481.633 138.986L478.067 137.935C478.067 137.935 489.976 136.127 488.664 125.883L492.634 128.532H492.625Z",
    fill: "#F2CCAA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M470.212 138.734C470.212 138.734 465.704 152.779 465.41 157.556C465.124 162.341 474.03 225.476 474.392 227.68C474.728 229.757 477.31 231.077 477.31 231.077C477.31 231.077 478.496 231.775 480.186 231.296C482.533 230.632 483.281 229.841 483.281 229.841C483.281 229.841 486.797 184.805 484.618 168.725C482.449 152.636 482.423 138.726 482.423 138.726H470.212V138.734Z",
    fill: "#163560"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M489.328 138.313C489.328 138.313 496.208 147.548 496.855 153.788C497.495 160.029 497.865 181.954 499.227 188.043C500.598 194.132 505.619 205.839 505.619 224.82C505.619 224.82 505.097 225.905 503.483 226.486C502.97 226.671 502.28 226.847 501.607 227.007C500.278 227.31 498.916 226.662 498.31 225.443C494.913 218.605 484.097 196.554 483.542 191.979C483.147 188.741 479.732 167.303 472.289 154.722C470.498 151.702 473.383 139.693 473.383 139.693L489.328 138.313Z",
    fill: "#1C468A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M469.489 136.564C469.489 136.564 471.297 137.994 474.896 138.07C479.194 138.154 489.841 136.976 489.841 136.976C489.841 136.976 490.312 138.297 490.295 139.693C490.295 139.693 477.285 142.973 469.749 140.172C469.749 140.172 468.774 138.347 469.48 136.564H469.489Z",
    fill: "#233862"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M473.871 141.77C472.786 141.77 471.911 140.778 471.911 139.55C471.911 138.322 472.794 137.33 473.871 137.33C474.947 137.33 475.83 138.322 475.83 139.55C475.83 140.778 474.947 141.77 473.871 141.77ZM473.871 137.977C473.147 137.977 472.559 138.684 472.559 139.55C472.559 140.416 473.147 141.123 473.871 141.123C474.594 141.123 475.183 140.416 475.183 139.55C475.183 138.684 474.594 137.977 473.871 137.977Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M487.919 120.798L474.594 132.402L490.478 150.643L503.804 139.039L487.919 120.798Z",
    fill: "#7091C5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M486.839 139.146C486.839 139.146 481.658 139.945 481.675 141.097C481.692 142.258 482.743 144.352 483.794 144.52C485.123 144.731 487.764 141.299 487.764 141.299L486.839 139.146Z",
    fill: "#BF8F68"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M486.73 139.424C486.73 139.424 484.997 138.793 483.719 139.054C482.449 139.315 481.272 139.121 481.557 139.584C481.843 140.046 483.567 139.878 483.845 140.055C484.114 140.24 484.122 140.122 484.122 140.122L486.73 139.424Z",
    fill: "#BF8F68"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M488.479 107.205C488.479 107.205 494.997 107.659 497.495 113.739C499.992 119.812 504.736 130.013 504.736 131.729C504.736 133.444 502.087 138.734 487.865 141.77C487.865 141.77 486.393 140.223 486.486 138.995C486.486 138.995 495.367 131.367 495.342 130.476C495.299 128.794 493.887 126.565 486.09 118.769C483.971 116.649 488.479 107.196 488.479 107.196V107.205Z",
    fill: "#C3C3E1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3952 178.754C43.9512 164.495 44.6319 158.216 44.8264 153.747C44.8264 153.747 44.9236 145.66 35.1018 143.319C27.8084 141.616 21.7792 145.766 21.9737 150.448C22.8489 170.773 28.1974 234.832 28.1974 234.832C28.1974 234.832 31.1147 234.726 32.5734 234.832C32.5734 234.832 32.5734 234.3 32.9624 232.704C34.9073 222.276 41.0338 190.991 42.3952 178.754Z",
    fill: "url(#paint2_linear_4269_73372)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0603 229.937H27.809L27.7118 235.364C27.7118 236.003 27.7118 237.705 29.9484 237.705C32.1851 237.705 37.7281 237.705 37.7281 237.705C38.4088 237.705 39.673 236.748 37.8253 235.79C36.1721 234.939 33.9355 233.874 33.352 233.449C32.7686 232.917 33.0603 229.937 33.0603 229.937Z",
    fill: "#C3C3E1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8749 178.328C13.9997 163.324 13.8052 155.024 13.8052 155.024C13.8052 155.024 14.097 145.021 24.1133 143.531C31.5039 142.361 37.3386 147.043 36.8524 151.831C36.2689 158.11 36.4634 168.538 35.102 179.711C31.9901 204.398 26.6416 233.448 26.6416 233.448C26.5444 234.938 25.4747 236.002 24.016 235.896C22.5573 235.79 21.5849 235.151 21.4876 233.661C20.0289 223.02 15.6529 190.671 14.8749 178.328Z",
    fill: "#DDDBD8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5441 230.895H21.2928L21.1955 236.322C21.1955 236.96 21.1955 238.663 23.4322 238.663C25.6688 238.663 31.2119 238.663 31.2119 238.663C31.8926 238.663 33.1568 237.705 31.3091 236.747C29.6559 235.896 27.4193 234.832 26.8358 234.406C26.2523 233.981 26.5441 230.895 26.5441 230.895Z",
    fill: "#C3C3E1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9711 155.45C14.6793 153.428 44.5338 153.215 44.3393 155.237C44.1448 158.536 35.6844 169.496 35.0037 169.602C33.7395 169.602 15.749 160.025 14.9711 155.45Z",
    fill: "#DDDBD8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3901 102.138C24.4047 100.435 34.032 100.541 40.4502 107.245C47.8409 115.013 46.9657 128.102 46.5767 135.657C46.285 140.765 44.5346 158.216 44.5346 158.216C44.5346 158.216 14.8746 158.322 13.9022 158.322C13.8049 155.981 13.4159 145.447 11.6655 128.953C9.81785 111.395 18.3755 103.84 21.3901 102.138Z",
    fill: "url(#paint3_radial_4269_73372)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7566 159.974C21.7566 159.974 19.5433 161.551 19.2397 161.837C16.9283 159.893 11.9114 155.151 7.06216 148.409C7.06216 148.409 8.35437 144.361 14.6553 142.438C15.7621 148.62 21.7566 159.974 21.7566 159.974Z",
    fill: "#DCB38B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4438 108.763C18.0838 100.934 8.21912 123.615 6.47851 130.058C5.86787 132.193 3.87177 133.207 3.37693 135.615C3.02475 137.288 5.0316 139.336 3.89089 140.58C1.00121 143.956 3.06595 146.142 3.68735 147.07L11.4503 150.175C11.4503 150.175 14.7429 148.999 15.4294 146.327C15.7726 144.992 15.7529 142.264 16.7778 140.748C19.3445 136.789 24.6959 132.244 26.6944 129.984C34.0222 121.698 35.3688 112.719 29.4438 108.763Z",
    fill: "#8B8CC4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3253 85.5376C34.3253 85.5376 34.2281 98.7325 34.2281 99.6902C34.2281 100.648 34.2281 102.776 35.6868 103.627C33.1584 104.798 29.7548 102.457 27.4209 101.925C24.1145 101.074 21.8779 101.925 21.8779 101.925C21.8779 101.925 22.6559 101.286 22.5586 98.9453C22.5586 97.562 22.6559 85.5376 22.6559 85.5376H34.3253Z",
    fill: "url(#paint4_radial_4269_73372)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9643 85.8315C26.8694 85.8528 26.7978 85.9779 26.7262 86.103L26.4332 88.3499C26.2383 89.7023 25.2861 90.7885 24.0759 91.1691C23.981 91.1904 23.8628 91.1079 23.7446 91.0253C23.2969 90.3624 21.7905 87.6469 20.6272 82.0188C20.2544 80.3576 21.1151 78.4195 22.6333 78.0788L29.6549 76.5031C31.7423 76.0347 33.893 77.6242 34.5471 80.0948L35.3859 83.8326C35.9217 86.2206 29.2649 85.4243 26.9643 85.8315Z",
    fill: "#3A312E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4198 88.7301C26.0235 88.7301 24.8915 87.4915 24.8915 85.9635C24.8915 84.4355 26.0235 83.1968 27.4198 83.1968C28.8162 83.1968 29.9482 84.4355 29.9482 85.9635C29.9482 87.4915 28.8162 88.7301 27.4198 88.7301Z",
    fill: "#DCB38B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8547 95.2748C33.49 96.2543 29.0222 93.2218 27.8322 88.3631L26.644 83.0679C26.178 80.9913 27.3233 78.9894 29.221 78.5635L37.6659 76.6684C37.8556 76.6258 37.9738 76.7084 38.0204 76.916L41.0278 89.8733C41.4921 92.3865 40.132 94.7638 37.8547 95.2748Z",
    fill: "#DCB38B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5213 87.1577C39.5679 87.3654 39.8043 87.5305 39.9708 87.3841C40.1372 87.2376 40.2321 87.2164 40.3037 87.0912L41.1128 86.2553C41.4224 85.8587 41.4008 85.3182 41.1178 84.9455L39.9377 83.6835C39.5598 83.3321 39.3717 82.9381 39.2552 82.4189L38.591 82.568L39.5213 87.1577Z",
    fill: "#DCB38B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6477 83.6355C36.5029 83.0055 36.6401 82.436 36.9541 82.3635C37.2681 82.291 37.64 82.7431 37.7848 83.3731C37.9295 84.0032 37.7923 84.5727 37.4783 84.6451C37.1643 84.7176 36.7924 84.2656 36.6477 83.6355Z",
    fill: "#605D5A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4333 77.8238C33.3242 77.7518 31.5463 77.8236 29.4588 78.292C26.8736 78.7631 24.3816 79.6495 23.6691 80.0275C23.4793 80.0701 23.3612 79.9876 23.3146 79.7799L23.1515 79.0531C22.7104 76.6437 23.5496 74.1652 26.2996 73.9844C30.5195 73.6917 29.7654 72.5522 31.4501 72.0651C33.1347 71.578 33.8155 73.2792 34.5979 73.2127C36.3058 72.8295 35.4853 70.5053 38.1154 70.6785C40.391 70.604 43.3953 78.2182 35.4333 77.8238Z",
    fill: "#3A312E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M25.876 79.2051C27.4475 77.3256 30.2225 76.8119 31.0163 79.9055C31.5306 81.7531 30.6733 82.818 30.4352 83.0895C30.1023 83.3823 29.2466 84.0106 28.3694 84.0984C27.587 84.1649 27.0177 84.2927 26.733 84.3565C26.5432 84.3991 26.425 84.3166 26.4017 84.2128C26.0256 83.4247 24.947 80.395 25.876 79.2051Z",
    fill: "#3A312E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5977 89.2317C36.7375 89.8547 37.2801 90.4963 38.0142 90.6587C38.3454 90.8025 38.8199 90.696 39.0812 90.5283C39.4375 90.3393 39.5806 90.0891 39.7005 89.735C39.7721 89.6099 39.6539 89.5274 39.5357 89.4448L39.4408 89.4661C38.8715 89.5939 38.5869 89.6578 38.184 89.6391C37.8761 89.5992 37.4266 89.3728 36.859 89.064C36.7408 88.9815 36.6692 89.1066 36.5977 89.2317C36.5977 89.2317 36.5744 89.1279 36.5977 89.2317Z",
    fill: "#BF8F68"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4269_73372",
    x: 21.3042,
    y: 0,
    width: 460.372,
    height: 249.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 10,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4269_73372"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8375 0 0 0 0 0.8375 0 0 0 0 0.8375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4269_73372"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4269_73372",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4269_73372",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(480.218 100.197) scale(5.14733 5.11001)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B643D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8819,
    stopColor: "#BA8A63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "#BF8F68"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4269_73372",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(477.788 94.5231) rotate(172.527) scale(3.99509 4.1824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000320513,
    stopColor: "#9B643D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8822,
    stopColor: "#BA8A63",
    stopOpacity: 0.1178
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8F68",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4269_73372",
    x1: 6.92802,
    y1: 179.531,
    x2: 41.6254,
    y2: 190.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A4A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763101,
    stopColor: "#5F5F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2549,
    stopColor: "#8C8B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4268,
    stopColor: "#AFAEAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#C8C7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7343,
    stopColor: "#D8D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8524,
    stopColor: "#DDDBD8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4269_73372",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.0677 137.144) rotate(180) scale(27.3831 29.9639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2465,
    stopColor: "#7A7BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6327,
    stopColor: "#8788C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8CC4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4269_73372",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5944 89.4932) rotate(180) scale(11.9803 14.2163)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#915A37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1796,
    stopColor: "#AC7A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3657,
    stopColor: "#C1936D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5597,
    stopColor: "#D0A57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7649,
    stopColor: "#D9B088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCB38B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataImage);
export default __webpack_public_path__ + "static/media/noDataImage.e842280859097408b4965483d9988223.svg";
export { ForwardRef as ReactComponent };